<template>
  <div :class="[$style.container, mode === 'popup' && $style.popup]">
    <!-- 普通模式 -->
    <Loading v-if="mode === 'normal'" :loading="loading">
      <Item title="邮箱">
        <el-input v-model="email" placeholder="请输入邮箱"></el-input>
      </Item>
      <Item title=" ">
        <Button type="primary" @click="addEmail">添加</Button>
      </Item>
    </Loading>

    <!-- 弹窗模式 -->
    <el-dialog
      v-if="mode === 'popup'"
      :custom-class="$style.dialog"
      title="添加邮箱认证"
      :visible="visible"
      @close="close"
    >
      <Loading :loading="loading">
        <Item title="邮箱">
          <el-input v-model="email" placeholder="请输入邮箱"></el-input>
        </Item>

        <Item title=" ">
          <Button type="primary" size="small" @click="addEmail">添加</Button>
          <Button size="small" :class="$style.btn_cancel" @click="close">
            取消
          </Button>
        </Item>
      </Loading>
    </el-dialog>
  </div>
</template>

<script>
import { createEmail } from "@server";

export default {
  name: "EmailPopup",
  props: {
    mode: {
      // normal - 普通模式 ，popup - 弹窗模式
      type: String,
      default: "normal",
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      email: "", // 邮箱
      loading: false,
    };
  },
  methods: {
    async addEmail() {
      if (!this.email) {
        this.$message({ message: "请输入邮箱!", type: "warning" });
        return;
      }

      this.loading = true;
      const data = { email: this.email };
      const res = await createEmail(data);

      if (res.code == 200) {
        this.$message({
          message: "认证邮箱已发送，请注意查收!",
          type: "success",
        });
        this.$emit("success");
        this.close();
      } else {
        this.$message({ message: res.message, type: "warning" });
      }
      this.loading = false;
    },

    close() {
      this.email = "";
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" module scoped>
.container {
  min-height: rem(600);

  &.popup {
    min-height: unset;
    height: 0;
  }

  :global {
    ::v-deep .gl-item {
      margin-bottom: rem(40);
    }

    .el-input {
      width: rem(300);
    }
  }

  ::v-deep .dialog {
    width: auto;

    :global {
      .el-dialog__header {
        padding: 10px rem(50);

        .el-dialog__title {
          font-size: max(rem(20), 16px);
          color: #333;
          line-height: 32px;
        }
      }
      .el-dialog__body {
        padding: rem(50) rem(60);
      }
    }
  }

  .btn_cancel {
    color: $white;
    background-color: #777777;
    margin-left: rem(10);
  }
}
</style>
